import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_API_URL;
export const getMyReferrals = async (token) => {
  try {
    const res = await axios.get(`${BACKEND_URL}/referrals/my-referrals`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (err) {
    console.error("Failed to load referrals:", err);
    return { success: false, referrals: [] };
  }
};
export const generateReferralCode = async (token) => {
  try {
    const res = await axios.post(
      `${BACKEND_URL}/referrals/generate`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Failed to generate referral code:", err);
    throw err;
  }
};
